<template>
	<v-autocomplete
		:value="value" attach=""
		:items="staffs"
		outlined clearable
		chips small-chips
		item-value="id"
		item-text="full_name"
		color="primary"
		:disabled="disabled"
		prepend-inner-icon="mdi-account-outline"
		:error-messages="getErrorMessage"
		hide-details="auto"
		label="STAFF" placeholder="Start typing"
		@input="$emit('input', $event)"
		@change="$emit('change', $event)"
		:menu-props="{
			transition: 'scale-transition'
		}"
	/>
</template>
<script>
import {mapGetters} from "vuex";
import FormFieldError from "@/mixins/FormFieldError.js";

export default {
	name: "StaffSelect",
	mixins: [FormFieldError],
	props: {
		value: {
			required: true
		},
		errors: {
			type: Object,
			required: false,
			default: () => {
			}
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	emits: ["input", "change"],
	data: () => ({
		name: "user",
		search: null
	}),
	computed: {
		...mapGetters({
			staffs: "staff/list"
		})
	}
}
</script>
